import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import * as model from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { TicketCreationDTO } from "../../services/webservice"

@Injectable()
export class AccountApi {
	private accountUrl = '/auth/accounts';
	private merchantUrl = '/auth/merchants'

	constructor(private httpClient: HttpClient, private logger: Logger) {}

	public createAccount(account: model.AccountModel): Observable<model.AccountModel> {
		let body = JSON.stringify(account)
		return this.httpClient.post(this.accountUrl, body)
			.map(response => response.json())
	}

	public updateAccount(account: model.AccountModel): Observable<model.AccountModel> {
		if(!account.password){
			delete account["password"]
		}
		let body = JSON.stringify(account)
		return this.httpClient.post(this.accountUrl + '/' + account.id, body)
			.map(response => response.json())
	}

	public getAccountsForMerchant(merchantId: string): Observable<model.AccountModel[]> {
		return this.httpClient.get(this.merchantUrl + '/' +  merchantId)
			.map(response => response.json())
	}

	public getMerchantAccountById(accountId: string): Observable<model.AccountModel> {
		return this.httpClient.get(this.accountUrl + '/' + accountId)
			.map(response => response.json())
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/account-api.service.ts